import { render, staticRenderFns } from "./RevisedResume.vue?vue&type=template&id=5f93530e&scoped=true&"
import script from "./RevisedResume.vue?vue&type=script&lang=js&"
export * from "./RevisedResume.vue?vue&type=script&lang=js&"
import style0 from "./RevisedResume.vue?vue&type=style&index=0&id=5f93530e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f93530e",
  null
  
)

export default component.exports